import { render } from "./Step2Component.vue?vue&type=template&id=e754b770&scoped=true"
import script from "./Step2Component.vue?vue&type=script&lang=js"
export * from "./Step2Component.vue?vue&type=script&lang=js"

import "./Step2Component.vue?vue&type=style&index=0&id=e754b770&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e754b770"]])

export default __exports__